module.exports = __webpack_public_path__ + "img/id-card.1e969b73.svg";